import { FormatAirwallexBeneficiaryForSubmissionUseCase } from './FormatAirwallexBeneficiaryForSubmissionUseCase'

export const formatAirwallexBeneficiaryForSubmissionUseCase =
  new FormatAirwallexBeneficiaryForSubmissionUseCase().execute
